import React from 'react';

import { useMediaQuery } from '@pkg/providers';

import { Button } from '../../Sections/Profile/Buttons';
import { Sizes } from '../../Sections/Profile/Buttons/Button/types';
import { Colors, Variants } from '../../Sections/Profile/Buttons/ButtonBase';

import { SuffixWrapper } from './DepActionBanner.style';

export interface DepActionBannerSuffixProps {
    actionContent: string;
    ariaLabel?: string;
    disabled?: boolean;
    success?: boolean;
    onAction?(): void;
}

export function DepActionBannerSuffix({
    actionContent,
    ariaLabel,
    disabled = false,
    success = false,
    onAction,
}: DepActionBannerSuffixProps) {
    const { tablet } = useMediaQuery();

    const isDisabled = disabled || !onAction;

    return (
        <SuffixWrapper>
            <Button
                aria-label={ariaLabel}
                disabled={isDisabled}
                color={getActionBannerSuffixColor({ disabled: isDisabled, success })}
                variant={getActionBannerSuffixVariant({ disabled: isDisabled })}
                size={tablet ? Sizes.small : Sizes.medium}
                onClick={onAction}
            >
                {actionContent}
            </Button>
        </SuffixWrapper>
    );
}

export function getActionBannerSuffixColor({
    disabled,
    success,
}: Pick<DepActionBannerSuffixProps, 'disabled' | 'success'>) {
    if (disabled) return Colors.secondary;

    return success ? Colors.success : Colors.primary;
}

export function getActionBannerSuffixVariant({ disabled }: Pick<DepActionBannerSuffixProps, 'disabled'>) {
    return disabled ? Variants.solid : Variants.yat;
}
